// src/api/communications.ts
import { fetchJson } from './apiClient';

export type SmsProviderKey = 'twilio' | 'vonage' | 'africastalking' | 'bulksmstanzania' | 'vodacom' | 'tigo' | 'airtel';

export type CommunicationsSettings = {
  sms?: {
    enabled?: boolean;
    defaultProvider?: SmsProviderKey;
    throttlePerMinute?: number;
    providers?: Partial<Record<SmsProviderKey, Record<string, any> & { enabled?: boolean }>>;
  };
  email?: {
    enabled?: boolean;
    useSendGrid?: boolean;
  throttlePerMinute?: number;
    smtp?: { host?: string; port?: number; user?: string; pass?: string };
    sendgrid?: { apiKey?: string };
    from?: string;
  };
};

export async function getCommunicationsSettingsClient(): Promise<CommunicationsSettings> {
  return await fetchJson<CommunicationsSettings>('/api/admin/communications-settings', { method: 'GET' });
}

export async function updateCommunicationsSettingsClient(settings: CommunicationsSettings): Promise<CommunicationsSettings> {
  return await fetchJson<CommunicationsSettings>('/api/admin/communications-settings', {
    method: 'PUT',
    body: JSON.stringify(settings ?? {}),
  });
}

export async function processApprovedBulkRequests(limit = 20): Promise<{ ok: boolean; processed?: number }>
{
  return await fetchJson<{ ok: boolean; processed?: number }>('/api/admin/bulk-requests/process', {
    method: 'POST',
    body: JSON.stringify({ limit }),
  });
}

export async function sendSmsNow(recipients: string[], message: string, provider?: SmsProviderKey): Promise<{ ok: boolean; sent: number; failed: number }>{
  return await fetchJson('/api/admin/send-now/sms', { method: 'POST', body: JSON.stringify({ recipients, message, provider }) });
}

export async function sendEmailNow(recipients: string[], subject: string, message: string): Promise<{ ok: boolean; sent: number; failed: number; skipped?: number }>{
  return await fetchJson('/api/admin/send-now/email', { method: 'POST', body: JSON.stringify({ recipients, subject, message }) });
}

export default {
  getCommunicationsSettingsClient,
  updateCommunicationsSettingsClient,
  processApprovedBulkRequests,
  sendSmsNow,
  sendEmailNow,
};
